module.exports = __webpack_public_path__ + "static/media/accesoriosDisabled.6904cc7a.svg";